import field from './admin/field';
import page from './admin/page';
import survey from './admin/survey';
import user from './admin/user';

export default {
  namespaced: true,
  state: {
    formChanged: false,
  },
  mutations: {
    setFormChanged(state, status) {
      state.formChanged = status;
    },
  },
  modules: {
    field,
    page,
    survey,
    user,
  },
};
